// src/modules/LiberaProximaVenda/services/customerService.js
import { fetchData } from '../../../utils/datasource';

/**
 * Utility function to add delay between requests
 * @param {number} ms - Milliseconds to wait
 * @returns {Promise<void>}
 */
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Fetches all customers from the API with pagination support
 * @param {number} maxPages - Maximum number of pages to fetch (default: 20)
 * @returns {Promise<Array>} Array of customer objects with code, store, and name properties
 * @throws {Error} If the API request fails
 */
export const fetchCustomers = async (maxPages = 20) => {
    return []
  try {
    let allCustomers = [];
    let currentPage = 1;
    let hasNext = true;

    console.log('Starting to fetch customers...');

    while (hasNext && currentPage <= maxPages) {
      console.log(`Fetching customers page ${currentPage}...`);
      
      const response = await fetchData(
        `/api/crm/v1/customerVendor?entityType=C&pageSize=150&page=${currentPage}`,
        'GET',
        {},
        30000 // 30 seconds timeout for each request
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch customers on page ${currentPage}`);
      }

      const result = await response.json();

      // Transform API response to match the component's expected format
      const customers = result.items.map((item) => ({
        code: item.code,
        storeId: item.storeId,
        name: item.name.trim(),
        shortName: item.shortName.trim(),
        companyInternalId: item.companyInternalId,
        type: item.type,
      }));

      allCustomers = [...allCustomers, ...customers];
      hasNext = result.hasNext;
      
      console.log(`Fetched ${customers.length} customers from page ${currentPage}. Total: ${allCustomers.length}`);

      currentPage++;

      // Add small delay between requests to avoid overwhelming the server
      if (hasNext && currentPage <= maxPages) {
        await delay(100);
      }
    }

    if (hasNext && currentPage > maxPages) {
      console.warn(`Stopped fetching at page ${maxPages}. There are more customers available.`);
    }

    console.log(`Finished fetching customers. Total: ${allCustomers.length}`);
    return allCustomers;
  } catch (error) {
    console.error('Error fetching customers:', error);
    throw error;
  }
};
